import { NavLink, Navigate, Route, Routes } from 'react-router-dom'
import { useTheme } from './hooks/useTheme'
import { useIssue } from './hooks/useIssue'
import { PwaStatus } from './components/PwaStatus'
import { TodayPage } from './pages/TodayPage'
import { WeeklyPage } from './pages/WeeklyPage'
import { LibraryPage } from './pages/LibraryPage'
import { VocabularyPage } from './pages/VocabularyPage'
import { SettingsPage } from './pages/SettingsPage'

const navigation = [
  { to: '/today', label: '今日', short: '今' },
  { to: '/week', label: '本周', short: '周' },
  { to: '/library?tab=saved', label: '资料库', short: '库' },
  { to: '/vocabulary', label: '词汇', short: '词' },
  { to: '/settings', label: '设置', short: '设' },
]

export default function App() {
  const { theme, toggleTheme } = useTheme()
  const issueState = useIssue()

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="topbar__inner">
          <NavLink to="/today" className="brand" aria-label="Daily Read 今日阅读">
            <span className="brand__mark" aria-hidden="true"><i /><i /></span>
            <span>
              <strong>Daily Read</strong>
              <small>Daily briefing</small>
            </span>
          </NavLink>
          <button className="icon-button" type="button" onClick={toggleTheme} aria-label={theme === 'light' ? '切换到深色模式' : '切换到浅色模式'}>
            <span aria-hidden="true">{theme === 'light' ? '◐' : '○'}</span>
          </button>
        </div>
      </header>

      <main id="main-content" className="main-content">
        <Routes>
          <Route path="/" element={<Navigate to="/today" replace />} />
          <Route path="/today" element={<TodayPage {...issueState} />} />
          <Route path="/week" element={<WeeklyPage />} />
          <Route path="/saved" element={<Navigate to="/library?tab=saved" replace />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/vocabulary" element={<VocabularyPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/today" replace />} />
        </Routes>
      </main>

      <nav className="bottom-nav" aria-label="主要导航">
        {navigation.map((item) => (
          <NavLink key={item.to} to={item.to} className={({ isActive }) => `bottom-nav__item${isActive ? ' is-active' : ''}`}>
            <span className="bottom-nav__glyph" aria-hidden="true">{item.short}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <PwaStatus />
    </div>
  )
}
